export default __webpack_public_path__ + "static/media/NotoSans-Bold.66ab2974.ttf";